import { CommonModule, DatePipe, DecimalPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BannerComponent } from "./components/banner/banner.component";
import { BidBoxComponent } from "./components/bid-box/bid-box.component";
import { BidShowcaseComponent } from "./components/bid-showcase/bid-showcase.component";
import { SlideshowComponent } from "./components/slideshow/slideshow.component";
import { TagsComponent } from "./components/tags/tags.component";
import { CampaignsComponent } from "./components/campaigns/campaigns.component";
import { TranslateModule } from '@ngx-translate/core';
import { DeleteDialogComponent } from "./components/delete-dialog/delete-dialog.component";
import { BidSearchResultComponent } from './components/bid-search-result/bid-search-result.component';
import { TagEditorComponent } from './components/tag-editor/tag-editor.component';
import { AutoCompleteModule } from "primeng/autocomplete";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BidElementComponent } from './components/bid-element/bid-element.component';
import { SuggestedAuctionsComponent } from './components/suggested-auctions/suggested-auctions.component';
import { CarouselModule } from 'primeng/carousel';
import { BidBoxHeaderComponent } from './components/bid-box-header/bid-box-header.component';
import { ImageInputFieldComponent } from './components/image-input-field/image-input-field.component';
import { MemoEditorComponent } from './components/memo-editor/memo-editor.component';
import { NoPaymentMethodDialogComponent } from './components/no-payment-method-dialog/no-payment-method-dialog.component';
import { ImageUploaderComponent } from "./components/image-uploader/image-uploader.component";
import { MemoCarouselComponent } from './components/memo-carousel/memo-carousel.component';
import { RouterModule } from "@angular/router";
import { SharedModule as SharedModuleNG } from 'primeng/api';
import { RippleModule } from "primeng/ripple";
import { PMemoEditorComponent } from './primeng/p-memo-editor/p-memo-editor.component';
import { ShellRenderDirective } from './directives/shell-render.directive';
import { ShellNoRenderDirective } from './directives/shell-no-render.directive';
import { SortAuctionsPipe } from "./pipes/sort-auctions.pipe";
import { ToastComponent } from './components/toast/toast.component';
import { StartConversationComponent } from "./components/start-conversation/start-conversation.component";

@NgModule({
  declarations: [
    SlideshowComponent,
    BidBoxComponent,
    TagsComponent,
    CampaignsComponent,
    BannerComponent,
    BidShowcaseComponent,
    DeleteDialogComponent,
    BidSearchResultComponent,
    TagEditorComponent,
    BidElementComponent,
    SuggestedAuctionsComponent,
    BidBoxHeaderComponent,
    ImageInputFieldComponent,
    MemoEditorComponent,
    NoPaymentMethodDialogComponent,
    ImageUploaderComponent,
    MemoCarouselComponent,
    PMemoEditorComponent,
    ShellRenderDirective,
    ShellNoRenderDirective,
    SortAuctionsPipe,
    ToastComponent,
    StartConversationComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    NgbModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    CarouselModule,
    RouterModule,
    SharedModuleNG,
    RippleModule
  ],
  exports: [
    SlideshowComponent,
    BidBoxComponent,
    TagsComponent,
    CampaignsComponent,
    BannerComponent,
    BidShowcaseComponent,
    BidSearchResultComponent,
    DeleteDialogComponent,
    TagEditorComponent,
    TranslateModule,
    BidElementComponent,
    SuggestedAuctionsComponent,
    NgbModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    ImageInputFieldComponent,
    MemoEditorComponent,
    NoPaymentMethodDialogComponent,
    ImageUploaderComponent,
    SharedModuleNG,
    MemoCarouselComponent,
    ShellRenderDirective,
    ShellNoRenderDirective,
    SortAuctionsPipe,
    StartConversationComponent
  ],
  providers: [
    DecimalPipe,
    DatePipe,
    SortAuctionsPipe
  ]
})
export class SharedModule { }